import React from "react";
import "./PuzzleMenu.css";
import { FaHome, FaUsers, FaUserTie, FaCalendarAlt } from "react-icons/fa";

const PuzzleMenu = ({ activeItem, onCenterItemClick }) => {
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const isAdmin = user.role === "admin";

  const menuItems = [
    { id: 100, label: "Anasayfa", icon: <FaHome />, position: "top-left" },
    { id: 102, label: "Talepler", icon: <FaUserTie />, position: "top-right" },
  ];

  const visibleItems = isAdmin
    ? menuItems
    : menuItems.filter((item) => item.id === 100);

  const menuClass = isAdmin ? "puzzle-menu" : "puzzle-menu single-button";

  return (
    <div className={menuClass}>
      {visibleItems.map((item) => (
        <div
          key={item.id}
          className={`puzzle-piece ${item.position} ${activeItem === item.id ? "active" : ""}`}
          onClick={() => onCenterItemClick(item.id)}
        >
          <div className="icon">{item.icon}</div>
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default PuzzleMenu;
